import { lazy } from 'react';

// Block C primitive demo pages — admin / engineer_l3 only, dev tooling
export const DesignIndex = lazy(() =>
  import('@/platform/design-system/pages/DesignIndex').then((m) => ({ default: m.DesignIndex }))
);

export const DesignStepperDemo = lazy(() =>
  import('@/platform/design-system/pages/StepperDemo').then((m) => ({ default: m.StepperDemo }))
);

export const DesignInspectorPanelDemo = lazy(() =>
  import('@/platform/design-system/pages/InspectorPanelDemo').then((m) => ({ default: m.InspectorPanelDemo }))
);

export const DesignUndoRedoDemo = lazy(() =>
  import('@/platform/design-system/pages/UndoRedoDemo').then((m) => ({ default: m.UndoRedoDemo }))
);

export const DesignVersionRibbonDemo = lazy(() =>
  import('@/platform/design-system/pages/VersionRibbonDemo').then((m) => ({ default: m.VersionRibbonDemo }))
);

export const DesignQuickConfigPopoverDemo = lazy(() =>
  import('@/platform/design-system/pages/QuickConfigPopoverDemo').then((m) => ({
    default: m.QuickConfigPopoverDemo,
  }))
);

export const DesignStatusPillDemo = lazy(() =>
  import('@/platform/design-system/pages/StatusPillDemo').then((m) => ({ default: m.StatusPillDemo }))
);

export const DesignSourcePillDemo = lazy(() =>
  import('@/platform/design-system/pages/SourcePillDemo').then((m) => ({ default: m.SourcePillDemo }))
);

export const DesignDndDemo = lazy(() =>
  import('@/platform/design-system/pages/DndDemo').then((m) => ({ default: m.DndDemo }))
);

export const DesignCanvasShellDemo = lazy(() =>
  import('@/platform/design-system/pages/CanvasShellDemo').then((m) => ({ default: m.CanvasShellDemo }))
);
